mutation studentHomeNumberDelete($studentId: ID!, $homeNumberId: ID!, $tz: String) {
  studentHomeNumberDelete(studentId: $studentId, homeNumberId: $homeNumberId) {
    id
    communicationCount
    first
    gradeLevel {
      canCurrentDelete
      name
      color {
        id
        name
      }
      icon {
        id
        name
      }
      id
      order
      orderDenominator
      orderNumerator
      studentCount
      team {
        id
        name
      }
    }
    groups {
      id
      name
      teacher {
        id
        first
        last
      }
    }
    homeNumbers {
      id
      label
      formattedNumber
    }
    last
    mostRecentCommunication
    positivity
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
  }
}
